import React from 'react';
import { Helmet } from "react-helmet";

const TermsOfUse = () => (
  <>
    <Helmet>
      <title>Terms of Use | Platform Engineering | Fepsec</title>
    </Helmet>
    <div className="container mx-auto py-16 px-4">
      <h1 className="text-4xl font-bold mb-6">Terms of Use</h1>
      <p className="mb-4">By using our website and services, you agree to comply with our terms of use. Please read these terms carefully before engaging with our offerings.</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Use our services for lawful purposes only</li>
        <li>Respect intellectual property rights</li>
        <li>Do not misuse or attempt to disrupt our services</li>
        <li>We may update these terms at any time</li>
      </ul>
      <p>Contact us for any questions regarding our terms.</p>
    </div>
  </>
);

export default TermsOfUse;
